export const menuItems = [
  {
    id: 1,
    name: "ワンカラー",
    description: "シンプルな単色ジェル。上品な発色で指先を美しく演出します。",
    price: "¥6,000〜",
    duration: "約60分",
    image: "https://public.readdy.ai/ai/img_res/f7c7168700e4af133fa518881e2b8ac5.jpg"
  },
  {
    id: 2,
    name: "フレンチネイル",
    description: "清潔感と上品さを兼ね備えた定番フレンチ。細めラインで大人の洗練を表現。",
    price: "¥8,000〜",
    duration: "約75分",
    image: "https://readdy.ai/api/search-image?query=classic%20French%20manicure%20nail%20art%2C%20delicate%20white%20tips%20on%20nude%20pink%20base%2C%20elegant%20and%20refined%20nail%20design%2C%20luxury%20nail%20salon%20photography%2C%20white%20background%2C%20sophisticated%20feminine%20style%2C%20perfect%20nail%20shape&width=400&height=300&seq=menu2&orientation=landscape"
  },
  {
    id: 3,
    name: "グラデーション",
    description: "肌馴染みの良いグラデーションで奥行きのある指先に。カラーバリエーション豊富。",
    price: "¥9,000〜",
    duration: "約80分",
    image: "https://readdy.ai/api/search-image?query=beautiful%20gradient%20ombre%20nail%20art%2C%20soft%20pink%20to%20white%20fade%2C%20gel%20nails%2C%20luxury%20nail%20design%2C%20elegant%20feminine%20style%2C%20nail%20salon%20photography%2C%20cream%20background%2C%20glossy%20finish%2C%20high-end%20nail%20manicure&width=400&height=300&seq=menu3&orientation=landscape"
  },
  {
    id: 4,
    name: "ネイルアート",
    description: "季節やシーンに合わせたオリジナルアート。石・パーツ・フラワーなどお好みで。",
    price: "¥10,000〜",
    duration: "約90分",
    image: "https://readdy.ai/api/search-image?query=artistic%20luxury%20nail%20art%20design%2C%20floral%20or%20stone%20embellishments%2C%20rose%20gold%20and%20pink%20tones%2C%20elegant%20detailed%20nail%20art%2C%20high-end%20nail%20salon%20photography%2C%20cream%20background%2C%20sophisticated%20and%20beautiful%20nail%20decoration&width=400&height=300&seq=menu4&orientation=landscape"
  },
  {
    id: 5,
    name: "ジェルオフ",
    description: "丁寧なオフで爪を傷めずリムーバル。他店施術のジェルも対応いたします。",
    price: "¥3,000〜",
    duration: "約30分",
    image: "https://readdy.ai/api/search-image?query=professional%20nail%20care%20treatment%2C%20nail%20technician%20hands%20working%20gently%20on%20client%20nails%2C%20clean%20professional%20nail%20salon%20setting%2C%20warm%20lighting%2C%20beige%20and%20white%20tones%2C%20luxury%20beauty%20service%20photography&width=400&height=300&seq=menu5&orientation=landscape"
  },
  {
    id: 6,
    name: "ハンドケア",
    description: "保湿・スクラブ・マッサージで手全体を美しく整えます。指先まで輝く手元に。",
    price: "¥4,000〜",
    duration: "約40分",
    image: "https://readdy.ai/api/search-image?query=luxury%20hand%20spa%20care%20treatment%2C%20moisturizing%20massage%20with%20cream%2C%20elegant%20woman%20hands%2C%20warm%20professional%20nail%20salon%20atmosphere%2C%20soft%20lighting%2C%20beige%20and%20cream%20tones%2C%20high-end%20beauty%20treatment%20photography&width=400&height=300&seq=menu6&orientation=landscape"
  }
];
